! function (e, t) {

    var o = "fixed-supported",
        n = e.document.createElement("div"),
        i = e.navigator.userAgent,
        c = e.document.documentElement;

    function d() {
        var i = "scrollTop" in e.document.body ? e.document.body.scrollTop : c.scrollTop;
        i !== t && i > 0 && e.document.body && (e.document.body.insertBefore(n, e.document.body.firstChild), n.getBoundingClientRect && 0 === n.getBoundingClientRect().top || (c.className = c.className.replace(o, "")), e.document.body.removeChild(n), e.removeEventListener ? e.removeEventListener("scroll", d, !1) : e.detachEvent("onscroll", d))
    }
    n.style.position = "fixed", n.style.top = 0, i.match(/Android 2\.[1256]/) && i.indexOf("AppleWebKit") > -1 && i.match(/Opera Mobi\/([0-9]+)/) && RegExp.$1 < 7458 && e.operamini && "[object OperaMini]" === {}.toString.call(e.operamini) && i.match(/Fennec\/([0-9]+)/) && RegExp.$1 < 6 || (c.className += " " + o, e.addEventListener ? e.addEventListener("scroll", d, !1) : e.attachEvent("onscroll", d)), e.FixedFixed = d
}(this);

// 1.Start of Eliran code : Add all this Variables to the head of the doc
var id = [];
var isBaseIn = false;
var isDockIn = false;
var numOfTops = 5;
var atLeastOneTop = false;
var is484 = false;
var numOfDocks = 0;
var numOfTopsmDocks = numOfDocks * numOfTops;
var docks = "";
var isPack = false;
// End of Eliran code

var SessionStorage = {
    getItem: function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1);
            if (c.indexOf(name) == 0)
                return c.substring(name.length, c.length);
        }
        return JSON.stringify(new Array());
    },
    setItem: function (cname, cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (2 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }
};


(function ($) {
    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g; // Regex for replacing addition symbol with a space
    var decode = function (str) {
        return decodeURIComponent(str.replace(decodeRE, " "));
    };
    $.parseParams = function (query) {
        var params = {},
            e;
        while (e = re.exec(query)) {
            var k = decode(e[1]),
                v = decode(e[2]);
            if (k.substring(k.length - 2) === '[]') {
                k = k.substring(0, k.length - 2);
                (params[k] || (params[k] = [])).push(v);
            } else
                params[k] = v;
        }
        return params;
    };
})(jQuery);

function checkAlreadyExist(items, pid) {
    var isfound = -1;
    for (var key in items) {
        if (items[key]['id'] == pid) {
            isfound = key;
            break;
        }
    }
    return isfound;
}

function storedata(pid, q, p, n, gim, catid) {
    if (typeof (Storage) !== "undefined") {
        var items = JSON.parse(SessionStorage.getItem("items"));
        if (items == null || items == '') {
            items = new Array();
        }
        var isexist = checkAlreadyExist(items, pid);
        // NEW (use the quantity you pass in; default to 1)
        if (isexist == -1) {
            items.push({
                id: pid,
                q: (typeof q === 'number' && q > 0) ? q : 1,
                p: p,
                n: n,
                gim: gim,
                catid: catid
            });
        } else {
            if (q == 0)
                delete items[isexist];
            items[isexist] = {
                id: pid,
                q: q,
                p: p,
                n: n,
                gim: gim,
                catid: catid
            };
        }
        SessionStorage.setItem("items", JSON.stringify(items));

    } else {
        alert("Your browser is old and is not supporting the functionality of the website.");
    }
}

var _syncedFromServer = false;
// Ștergem shadow-cart local să nu împingă resturi vechi
SessionStorage.setItem("items", JSON.stringify([]));

$(document).ready(function () {


    // Reset local shadow cart so we don't push stale items into Shopify on load
    SessionStorage.setItem("items", JSON.stringify([]));

    $.ajax({
        url: "/cart.js",
        dataType: "json",
        success: function (data) {
            var items = new Array();

            var cart_items = data["items"];
            for (var key in cart_items) {
                if (cart_items[key].variant_title) {
                    var cf = ' - ' + cart_items[key].variant_title;
                } else {
                    var cf = '';
                }
                items.push({
                    id: cart_items[key].id,
                    q: cart_items[key].quantity,
                    p: (cart_items[key].price / 100),
                    n: cart_items[key].product_title + cf
                });
            }
            SessionStorage.setItem("items", JSON.stringify(items));
            displayit(JSON.parse(SessionStorage.getItem("items")));
            // 2. Eliran Code : Add this line, updates cartStatus
            cartStatus(JSON.parse(SessionStorage.getItem("items")));
            // End of Eliran Code
            _syncedFromServer = true; // ✅ we’re safe to push after this

            // Auto-open the side cart when we were redirected here with ?opencart=1
            // (e.g. after adding to cart from the product page).
            try {
                var _p = new URLSearchParams(window.location.search);
                if (_p.get('opencart') === '1') {
                    showRightbar();
                    _p.delete('opencart');
                    var _qs = _p.toString();
                    if (window.history && history.replaceState) {
                        history.replaceState(null, '', window.location.pathname + (_qs ? '?' + _qs : '') + window.location.hash);
                    }
                }
            } catch (e) {}
        }
    });


    var window_width = $(window).width();

    function refreshitembox() {
        $('option').each(function () {
            var selector = $(this);
            var pid = selector.val();
            var items = JSON.parse(SessionStorage.getItem("items"));
            var isexist = checkAlreadyExist(items, pid);

            if (isexist != -1) {
                var q = items[isexist]['q'];
                $(this).data("quantity", q);
            }
        });
    }
    refreshitembox();

    $(".qplus").on("click", function () {

        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        quant.html(qant + 1);

        var cf = $(this).parent().find(".variant-title strong").text();

        if (cf) {
            cf = ' - ' + cf;
        } else {
            cf = '';
        }

        var name = $(this).closest('.p-item').find(".product-title").html().trim() + cf;
        var price = parseInt($(this).closest('.p-item').find(".pb-price").html().trim().substr(1));

        storedata($(this).data("id"), qant + 1, price, name, gim, catid);

        var items = JSON.parse(SessionStorage.getItem("items"));

        // 3. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of Eliran code
        displayit(items);
        updatecart();
    });

    function showRightbar() {
        $("#cartsum").css({
            'right': '0px',
        })
        $("#cartsum").css({
            'right': '0px',
        })

        $("#overlay").css({ 'display': 'block', })
        $("body.template-cart").css({ 'overflow': 'hidden' })
    }

    function hiddenRightbar() {

        if (window_width > 768) {
            $("#cartsum").css({
                'right': '-450px'
            });
        } else {
            $("#cartsum").css({
                'right': '-100%'
            });
        }
        $("#overlay").css({ 'display': 'none' });
        $("body.template-cart").css({ 'overflow': 'initial' })
    }

    $(".varidation-selection").on("click", function () {

        var button = $(this);

        button.addClass("added");
        button.html('Added to cart <span><img class="check-solid" src="https://cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/check-solid.svg?v=1591723521"></span>');

        var variantWrap = $(this).closest(".variant-wrap");
        var quant = variantWrap.find(".select-product-varidation option:selected");

        var gim = variantWrap.find(".hidden-value").data("img-src");
        var catid = variantWrap.find(".hidden-value").data("cat-id");
        var productId = parseInt(variantWrap.find(".select-product-varidation option:selected").val());
        var qant = parseInt(quant.data("quantity"));

        quant.data("quantity", qant + 1);
        var cf = variantWrap.find(".select-product-varidation option:selected").data("variant-size");
        if (cf == 'Default Title') cf = false;

        if (cf) {
            cf = ' - ' + cf;
        } else {
            cf = '';
        }

        var name = variantWrap.find(".hidden-value").data("product-title") + cf;
        var price = parseInt(variantWrap.find(".hidden-value").data("product-price").substr(1));
        storedata(productId, qant + 1, price, name, gim, catid);

        var items = JSON.parse(SessionStorage.getItem("items"));
        // 3. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);

        // End of Eliran code
        displayit(items);

        updatecart();


        setTimeout(function () {
            button.removeClass("added");
            button.text('$' + price + ' - Add to Cart');
        }, 900);


    });



    $(".qminus").on("click", function () {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        if (qant >= 1) {
            quant.html(qant - 1);
            var name = $(this).closest('.p-item').find(".product-title").html().trim();
            var price = parseInt($(this).closest('.p-item').find(".pb-price").html().trim().substr(1));
            storedata($(this).data("id"), qant - 1, price, name, gim, catid);
            var items = JSON.parse(SessionStorage.getItem("items"));
            // 4. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of Eliran code
            displayit(items);
            updatecart();
        }
    });

    $("#cartQty").on("click", function (e) {
        showRightbar();
        e.stopPropagation();
    })

    $("#gotocheckout").on("click", function (e) {
        showRightbar();
        e.stopPropagation();
    })

    $("#cartsum").on("click", ".view-cart", function () {
        hiddenRightbar();
    })

    $("#cartsum").click(function (e) {
        e.stopPropagation();
    });

    $(document).click(function () {
        hiddenRightbar();
    });



    $('select').on('change', function () {
        var selectText = $(this).closest('.variant-wrap').find('.selecttext');
        var buttonText = $(this).closest('.variant-wrap').find('button.varidation-selection')
        var selectedContent = $(this).find(":selected").text();
        var dataPrice = $(this).find(":selected").data("variant-price");
        selectText.html(selectedContent);
        buttonText.text(dataPrice + " - Add to Cart");
        var dataValue = $(this).find(":selected").data("value");
        $(this).closest('.variant-wrap').find("input.hidden-value").data("product-price", dataPrice);
    });


    $(".selecttext").click(function () {
        $(this).closest('.variant-wrap').find('.select-product-varidation').trigger('click');
    });

    $(".product-rows").on("click", ".qplus", function () {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        quant.html(qant + 1);
        var name = $(this).parent().parent().parent().find(".product-title").html().trim();
        var price = parseInt($(this).parent().parent().parent().find(".pb-price").html().trim().substr(1));
        storedata($(this).data("id"), qant + 1, price, name, gim, catid);
        var items = JSON.parse(SessionStorage.getItem("items"));
        // 5. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of eliran code
        displayit(items);
        updatecart();
    });
    $(".product-rows").on("click", ".qminus", function () {
        var quant = $(this).parent().find(".qquan");
        var qant = parseInt(quant.html());
        var gim = $(this).data("img-src");
        var catid = $(this).data("cat-id");

        if (qant >= 1) {
            quant.html(qant - 1);
            var name = $(this).parent().parent().parent().find(".product-title").html().trim();
            var price = parseInt($(this).parent().parent().parent().find(".pb-price").html().trim().substr(1));
            storedata($(this).data("id"), qant - 1, price, name, gim, catid);
            if (qant - 1 == 0) {
                $(this).parent().parent().parent().remove();
            }
            var items = JSON.parse(SessionStorage.getItem("items"));
            // 6. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of code
            displayit(items);
            updatecart();
        }
    });

    var cats = new Array();

    function is_cat_already_exist(pid) {
        var isfound = -1;
        for (key in cats) {
            if (cats[key]['id'] == pid) {
                isfound = key;
                break;
            }
        }
        return isfound;
    }


    $('document, body').on('click', '.js-rec-add', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation(); // oprește alte handler-e să înghită clickul

        var $btn = $(this);
        if ($btn.data('busy')) return; // protecție dublu-click
        $btn.data('busy', true);

        var variantId = Number($btn.data('id'));
        console.log('Attempting to add variant ID:', variantId);

        // Clear any previous error messages
        var $rec = $btn.closest('.rec');
        $rec.find('.rec-error').remove();

        // Debug: Check if this is Titanium die
        if (variantId === IDS.Titanium) {
            console.log('Adding Titanium die (Hero product)');
        } else if (variantId === IDS.Dock) {
            console.log('Adding Dock');
        }

        // For recommendation buttons, always use direct cart/add.js approach for reliability
        // Skip DOM option check and go directly to cart/add.js
        console.log('Using direct cart/add.js approach for recommendation button:', variantId);
        var payload = { id: variantId, quantity: 1 };

        // Additional validation for Titanium die
        if (variantId === IDS.Titanium) {
            console.log('Confirmed: Adding Titanium die with ID:', IDS.Titanium);
        }

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: payload,
            success: function (response) {
                console.log('Successfully added to cart:', response);
                // Don't call updatecart() immediately - let the sync happen first
                $.getJSON('/cart.js', function (cart) {
                    var items = [];
                    (cart.items || []).forEach(function (ci) {
                        var cf = ci.variant_title ? (' - ' + ci.variant_title) : '';
                        items.push({
                            id: ci.id,
                            q: ci.quantity,
                            p: (ci.price / 100),
                            n: ci.product_title + cf
                        });
                    });
                    SessionStorage.setItem('items', JSON.stringify(items));
                    cartStatus(items);
                    displayit(items);
                    // Remove the updatecart() call to avoid 429 errors
                    $btn.data('busy', false);
                });
            },
            error: function (xhr) {
                $btn.data('busy', false);
                console.error('Failed to add to cart:', xhr.status, xhr.responseText);

                // Afișează motivul (dacă e vreo cerință specială la Titanium)
                var msg = 'Could not add item.';
                try {
                    var resp = JSON.parse(xhr.responseText || '{}');
                    if (resp && resp.description) msg = resp.description;
                    else if (resp && resp.message) msg = resp.message;
                } catch (e) {
                    // Fallback messages based on status code
                    if (xhr.status === 422) {
                        msg = 'Product variant is not available or out of stock.';
                    } else if (xhr.status === 404) {
                        msg = 'Product not found.';
                    } else {
                        msg = 'Error ' + xhr.status + ': Could not add item to cart.';
                    }
                }

                if ($rec.find('.rec-error').length === 0) {
                    $rec.append("<div class='rec-error' style='margin-top:6px;font-size:12px;color:red;opacity:.8;'>" + msg + "</div>");
                } else {
                    $rec.find('.rec-error').text(msg);
                }
                console.warn('Add failed', variantId, xhr.status, msg);
            }
        });
    });






    function cartStatus(items) {
        var state = computeCartState(items);

        numOfTopsIn = state.numDice;               // "tops" = numărul de piese (dice)
        isBaseIn = false;                       // moștenire; nu mai avem "base", îl lăsăm false
        isDockIn = state.hasDock;
        atLeastOneTop = state.numDice > 0;
        isPopular = state.hasHero;               // Titanium în coș?
        numOfDocks = state.numDocks;
        docks = (numOfDocks > 1) ? "s" : "";
        numOfTopsmDocks = state.capacity;             // capacitatea totală (dock-uri × 5)
        numOfTops = state.slotsLeft;            // locuri libere rămase
        isPack = PACK_IDS.some(function (id) { return (state.qtyById[id] || 0) > 0; });

        // Compat pentru verificări vechi de "full collection" / "minimetal"
        isfullCollectionIn = (state.qtyById[IDS.Pack2] || 0) > 0;
        isMinimetalIn = (state.qtyById[IDS.MiniMetalPack1] || 0) > 0;
    }


    /***********************
 *  Constante & ID-uri *
 ***********************/
    var IDS = {
        Magnesium: 50908401566007,
        Tungsten: 50904879857975,
        Titanium: 50908393210167, // HERO (cel mai popular)
        Mirror: 50908391801143,
        Gold24k: 50908390359351, // 24k plated
        Copper: 50908388852023,
        CastIron: 50908388262199,
        BlackZirconium: 50908387344695,
        BlueTitanium: 50908386230583,
        Aluminium: 50908377612599,
        StainlessSteel: 50908374991159,
        Nickel: 50908353659191,
        Dock: 50904880152887,

        // packs
        MiniMetalPack1: 50904878383415,
        Pack2: 50904877990199
    };

    // toate piesele (dice) – fără dock & fără pack-uri
    var DICE_IDS = [
        IDS.Titanium, IDS.BlackZirconium, IDS.BlueTitanium, IDS.Gold24k,
        IDS.Mirror, IDS.Tungsten, IDS.Copper, IDS.CastIron,
        IDS.Magnesium, IDS.Aluminium, IDS.StainlessSteel, IDS.Nickel
    ];

    // ordinea preferată pentru recomandări (HERO primește prioritate)
    var PREFERRED_DICE_ORDER = [
        IDS.Titanium, IDS.BlackZirconium, IDS.BlueTitanium, IDS.Gold24k,
        IDS.Tungsten, IDS.Mirror, IDS.Copper, IDS.CastIron,
        IDS.Magnesium, IDS.Aluminium, IDS.StainlessSteel, IDS.Nickel
    ];

    // pack-uri (dacă vrei să conteze ca “n piese” în numărătoare)
    var PACK_IDS = [IDS.MiniMetalPack1, IDS.Pack2];
    var PACK_AS_DICE_COUNT = 2; // ⇦ ajustează la compoziția reală, dacă e altă valoare

    var HERO_DIE_ID = IDS.Titanium;
    var DOCK_ID = IDS.Dock;
    var DOCK_CAPACITY = 6;
    var FREE_SHIP = 79;

    var HERO_SELLING_PLAN_ID = null; // ex: '1234567890' dacă Titanium necesită plan
    var SELLING_PLAN_BY_VARIANT = {};
    SELLING_PLAN_BY_VARIANT[IDS.Titanium] = HERO_SELLING_PLAN_ID;

    // Product names mapping for recommendations
    var PRODUCT_NAMES = {};
    PRODUCT_NAMES[IDS.Titanium] = 'Titanium';
    PRODUCT_NAMES[IDS.BlackZirconium] = 'Black Zirconium';
    PRODUCT_NAMES[IDS.BlueTitanium] = 'Blue Titanium';
    PRODUCT_NAMES[IDS.Gold24k] = 'Gold 24k';
    PRODUCT_NAMES[IDS.Tungsten] = 'Tungsten';
    PRODUCT_NAMES[IDS.Mirror] = 'Mirror';
    PRODUCT_NAMES[IDS.Copper] = 'Copper';
    PRODUCT_NAMES[IDS.CastIron] = 'Cast Iron';
    PRODUCT_NAMES[IDS.Magnesium] = 'Magnesium';
    PRODUCT_NAMES[IDS.Aluminium] = 'Aluminium';
    PRODUCT_NAMES[IDS.StainlessSteel] = 'Stainless Steel';
    PRODUCT_NAMES[IDS.Nickel] = 'Nickel';
    PRODUCT_NAMES[IDS.Dock] = 'Dock';

    // Function to get product name
    function getProductName(variantId) {
        return PRODUCT_NAMES[variantId] || 'Unknown Product';
    }


    // === Imagini produse recomandate (completabile) ===
    var IMG_BY_ID = {};
    IMG_BY_ID[IDS.Titanium] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/Ti_4x_4bdd2f98-5c1d-43df-be0f-893fc8095922.png?v=1754370833';
    IMG_BY_ID[IDS.Dock] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/stainless_steel_dock_no_bg.png?v=1755183634';

    // (opțional, dacă vrei imagini și pentru alte piese)
    IMG_BY_ID[IDS.BlackZirconium] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/BZ_4x_5aa5d3ee-1012-4a42-b9ff-7ef8c43ecfa3.png?v=1754370432';
    IMG_BY_ID[IDS.StainlessSteel] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/SS_4x_7c268163-7ca1-461d-8361-34094327182f.png?v=1754369935';
    IMG_BY_ID[IDS.BlueTitanium] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/blu_ti_4x_e26c2082-283b-478d-83a9-0e7a6d1e87ea.png?v=1754370356';
    IMG_BY_ID[IDS.Gold24k] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/GOLD_4x_e6e2c4f5-99fb-425b-a27d-56e5bdfc6d24.png?v=1754370644';
    IMG_BY_ID[IDS.Tungsten] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/Tungtesn_4x-removebg-preview.png?v=1755198659';
    IMG_BY_ID[IDS.Copper] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/CU_4x_97de3792-4e3b-4812-bfb3-6bdbd49c7eca.png?v=1754370568';
    IMG_BY_ID[IDS.CastIron] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/CastIron_4x_f572e819-7377-4323-8309-517393c7518b.png?v=1754370496';
    IMG_BY_ID[IDS.Magnesium] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/maggy__4x_1.png?v=1754371246';
    IMG_BY_ID[IDS.Aluminium] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/AL_4x_793bc0d2-bee1-4378-8f2b-8a56c5b2a093.png?v=1754370020';
    IMG_BY_ID[IDS.StainlessSteel] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/SS_4x_7c268163-7ca1-461d-8361-34094327182f.png?v=1754369935';
    IMG_BY_ID[IDS.Nickel] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/Nickel_4x_9c244927-5996-4377-93b3-8e3ded20516b.png?v=1754369038';
    IMG_BY_ID[IDS.Mirror] = 'https://cdn.shopify.com/s/files/1/0948/5395/5895/files/Mirror_4x_c3f6dbf8-23da-4ad5-a567-e66378fe757e.png?v=1754370740';
    // etc.

    // Încearcă să rezolvi URL-ul imaginii pentru un variantId
    function resolveImageUrl(variantId) {
        // 1) catalog static
        if (IMG_BY_ID[variantId]) return IMG_BY_ID[variantId];

        // 2) din DOM – dacă există opțiunea #vi-<id> pe pagină
        var $opt = jQuery('#vi-' + variantId);
        if ($opt.length) {
            var $hv = $opt.closest('.variant-wrap').find('.hidden-value');
            var u = $hv.data('img-src');
            if (u) return u;
        }

        // 3) din local items (dacă e în coș și are 'gim')
        try {
            var items = JSON.parse(SessionStorage.getItem("items")) || [];
            for (var i = 0; i < items.length; i++) {
                if (Number(items[i].id) === Number(variantId) && items[i].gim) return items[i].gim;
            }
        } catch (e) { }

        // 4) fallback placeholder
        return '//cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/placeholder_150x.png?v=1';
    }


    /*********************************
     *  Utilitare pentru citit coșul *
     *********************************/
    function forEachItem(items, cb) {
        for (var k in items) {
            var it = items[k];
            if (it && it.q > 0) cb(it);
        }
    }

    function qtyInCart(items, id) {
        var q = 0;
        forEachItem(items, function (it) {
            if (Number(it.id) === Number(id)) q += Number(it.q || 0);
        });
        return q;
    }

    function computeCartState(items) {
        var subtotal = 0;
        var totalUnits = 0;
        var qtyById = {};

        forEachItem(items, function (it) {
            var id = Number(it.id);
            var q = Number(it.q || 0);
            var p = Number(it.p || 0);
            subtotal += p * q;
            totalUnits += q;
            qtyById[id] = (qtyById[id] || 0) + q;
        });

        // număr “dice” (piese)
        var numDice = 0;
        for (var i = 0; i < DICE_IDS.length; i++) {
            var dId = DICE_IDS[i];
            numDice += (qtyById[dId] || 0);
        }

        // pack-uri contează ca niște piese suplimentare (conservator: 2/pachet)
        for (var j = 0; j < PACK_IDS.length; j++) {
            var pk = PACK_IDS[j];
            numDice += (qtyById[pk] || 0) * PACK_AS_DICE_COUNT;
        }

        var numDocks = qtyById[DOCK_ID] || 0;
        var capacity = numDocks * DOCK_CAPACITY;
        var slotsLeft = Math.max(0, capacity - numDice);
        var overflow = Math.max(0, numDice - capacity);

        return {
            subtotal: subtotal,
            totalUnits: totalUnits,
            qtyById: qtyById,
            numDice: numDice,
            numDocks: numDocks,
            capacity: capacity,
            slotsLeft: slotsLeft,
            overflow: overflow,
            hasDock: numDocks > 0,
            hasHero: (qtyById[HERO_DIE_ID] || 0) > 0
        };
    }

    /*******************************************
     *  Alegem ce piesă concretă să recomandăm *
     *******************************************/
    function pickNextDie(state) {
        // prima piesă din ordinea preferată pe care clientul NU o are
        for (var i = 0; i < PREFERRED_DICE_ORDER.length; i++) {
            var id = PREFERRED_DICE_ORDER[i];
            if (!state.qtyById[id]) return id;
        }

        // Dacă utilizatorul are toate tipurile, găsește cea cu cantitatea cea mai mică
        // pentru a sugera diversitate în colecție
        var minQty = Infinity;
        var candidatesWithMinQty = [];

        for (var j = 0; j < PREFERRED_DICE_ORDER.length; j++) {
            var diceId = PREFERRED_DICE_ORDER[j];
            var qty = state.qtyById[diceId] || 0;
            if (qty < minQty) {
                minQty = qty;
                candidatesWithMinQty = [diceId];
            } else if (qty === minQty) {
                candidatesWithMinQty.push(diceId);
            }
        }

        // Dacă avem mai mulți candidați cu aceeași cantitate minimă,
        // rotește prin ei pe baza numărului total de articole din coș
        if (candidatesWithMinQty.length > 1) {
            var rotationIndex = state.totalUnits % candidatesWithMinQty.length;
            return candidatesWithMinQty[rotationIndex];
        }

        // Dacă avem un singur candidat, returnează-l
        return candidatesWithMinQty[0] || HERO_DIE_ID;
    }

    function pickDiceToFill(state) {
        return pickNextDie(state);
    }

    /********************************
     *  Logica de recomandare (scenarii)
     ********************************/
    function getRecommendation(state) {
        // Scenario 1: coș gol
        if (state.totalUnits === 0) {
            return {
                type: 'die',
                productId: HERO_DIE_ID,
                title: 'Add Titanium die',
                reason: 'Our most popular piece'
            };
        }

        // Scenario 2: sub pragul de livrare gratuită
        if (state.subtotal < FREE_SHIP) {
            if (!state.hasHero) {
                return {
                    type: 'die',
                    productId: HERO_DIE_ID,
                    title: 'Add Titanium die',
                    reason: 'Our most popular piece'
                };
            }
            if (state.numDice >= 2 && !state.hasDock) {
                return {
                    type: 'dock',
                    productId: DOCK_ID,
                    title: 'Add Dock to display your set',
                    reason: 'Display multiple pieces nicely'
                };
            }
            if (state.hasDock && state.slotsLeft > 0 && state.numDice > 0) {
                return {
                    type: 'die',
                    productId: pickDiceToFill(state),
                    title: 'Your dock can hold ' + state.slotsLeft + ' more dice',
                    reason: ''
                };
            }
            // fallback
            if (!state.hasDock) {
                return {
                    type: 'dock',
                    productId: DOCK_ID,
                    title: 'Add Dock',
                    reason: 'Level up your display'
                };
            }
            return {
                type: 'die',
                productId: pickNextDie(state),
                title: 'Add another featured die',
                reason: 'Get closer to free shipping'
            };
        }

        // Scenario 3: la / peste prag
        if (state.numDice >= 2 && !state.hasDock) {
            return {
                type: 'dock',
                productId: DOCK_ID,
                title: 'Add Dock to display your set',
                reason: 'You have enough pieces for a dock'
            };
        }
        if (state.overflow > 0) {
            return {
                type: 'dock',
                productId: DOCK_ID,
                title: 'Add another Dock',
                reason: 'You have more pieces than the dock can hold'
            };
        }
        if (state.hasDock && state.slotsLeft > 0 && state.numDice > 0) {
            var recommendedProductId = pickDiceToFill(state);
            var productName = getProductName(recommendedProductId);
            return {
                type: 'die',
                productId: recommendedProductId,
                title: 'Your dock can hold ' + state.slotsLeft + ' more dice',
                reason: 'Click to add ' + productName
            };
        }
        if (!state.hasHero) {
            return {
                type: 'die',
                productId: HERO_DIE_ID,
                title: 'Add Titanium die',
                reason: 'Our most popular piece'
            };
        }
        return {
            type: 'die',
            productId: pickNextDie(state),
            title: 'Add a contrasting die',
            reason: 'Add variety to your collection'
        };
    }

    /****************************************
     *  Randare în UI a recomandării curente
     ****************************************/
    function renderRecommendation(rec, state) {
        if (!document.getElementById('rec-styles')) {
            jQuery('head').append(
                "<style id='rec-styles'>" +
                ".rec{display:block}.rec-card{display:flex;align-items:center;gap:12px;text-decoration:none;border:none;background:transparent}" +
                ".rec-img{width:124px;height:84px;object-fit:contain;display:block;padding-bottom: 10px;}" +
                ".rec-copy{line-height:1.2;text-align:left}.rec-title{font-size:18px;font-weight:600;display:block}" +
                ".rec-reason{font-size:17px;opacity:.8;font-weight:bold;text-decoration:underline}" +
                "</style>"
            );
        }

        // Special case: if it's "Fill your dock", show dock image instead of die image
        var imageProductId = rec.productId;
        if (rec.title && rec.title.indexOf('Fill your dock') !== -1) {
            imageProductId = DOCK_ID;
        }

        var img = resolveImageUrl(imageProductId);
        var cls = (rec.type === 'dock') ? 'rec--dock' : 'rec--die';

        var html =
            "<span class='cart_empty rec " + cls + "'>" +
            "<button type='button' class='js-rec-add rec-card' data-id='" + rec.productId + "'>" +
            "<img class='rec-img' src='" + img + "' alt=''>" +
            "<span class='rec-copy'>" +
            "<span class='rec-title'>" + rec.title + "</span>" +
            (rec.reason ? "<span class='rec-reason'>" + rec.reason + "</span>" : "") +
            "</span>" +
            "</button>" +
            "</span>";

        jQuery(".cart_quantity .cart_empty").replaceWith(html);
    }



    function displayit(data) {
        var html = '<div class="clearfix-wrapper">';
        var quan = "";
        var total = sum = 0;
        var cart = "";
        var ctcount = 0;

        for (var n in data) {
            if (data[n] && data[n].q > 0) {
                html += '<div class="clearfix"><div class="col-sm-6 product-title">' + data[n].n + '</div>';
                html += '<div class="col-sm-2 pb-price">$' + data[n].p + '</div>';
                html += '<div class="col-sm-2"><div class="quantity">';
                html += '<span class="qminus" data-id="' + data[n].id + '" data-img-src="' + data[n].gim + '" data-cat-id="' + data[n].catid + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/></svg></span>';
                html += '<span class="qquan">' + data[n].q + '</span>';
                html += '<span class="qplus" data-id="' + data[n].id + '" data-img-src="' + data[n].gim + '" data-cat-id="' + data[n].catid + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"/></svg></span>';
                html += '</div><input type="hidden" id="updates_' + data[n].id + '" name="updates[]"value="' + data[n].q + '" pattern="[0-9]*" aria-label="quantity" data-id=""  class="js-qty__num"></div>';
                html += '<div class="col-sm-2"><a data-id="' + data[n].id + '" class="removeit" href="javascript:void(0);">Remove</a></div></div>';
                total += data[n].p * data[n].q;
                sum += parseInt(data[n].q);
                cart += '<div class="cart">';
                cart += '</div>';
                ctcount += parseInt(data[n].q);
            }

            refreshitembox();
        }



        jQuery('#cartQty span').text(ctcount);

        if (sum > 0) {
            $("#gotocheckout").addClass("active");
            $("#cartQty").show();
        } else {
            $("#gotocheckout").removeClass("active");
            $("#cartQty").hide();
        }
        var text = $(".total-price").text();
        html += '<div class="button-group"><a class="pay-now" href="/checkout/">Payment(' + (window.SHOP_CURRENCY || 'USD') + ' ' + total + ')</a><a class="view-cart">Return to Store <span><img src="https://cdn.shopify.com/s/files/1/0366/3973/5939/t/2/assets/return-arrow.svg?v=1591655795" /></span></a></div></div>';

        var shipping = 69 - total;


        const state = computeCartState(data);
        const rec = getRecommendation(state);
        renderRecommendation(rec, state);


        jQuery(".product-rows").html(html);
        // Sync quantities in product grid
        if (Array.isArray(data)) {
            data.forEach(function (item) {
                var selector = '.product-qquan.qquan-' + item.id;
                if (jQuery(selector).length) {
                    jQuery(selector).text(item.q);
                }
            });
        }
        jQuery(".payment-title > .total-price").html("$" + total);
    }


    // End Of Code! Importent! Replace this code with the displayit() function in the original file!

    var x;


    if (typeof (Storage) !== "undefined") {
        var items = JSON.parse(SessionStorage.getItem("items"));
        if (items == null || items == '') {
            $(".product-rows").html("");
        } else {
            // 8. Eliran Code : Add this line, updates cartStatus
            cartStatus(items);
            // End of code
            displayit(items);
        }
    }

    /* Public hook so other sections (e.g. the 2.0 product page) can refresh
       the mini-cart from the server and optionally open the drawer, reusing
       the exact same rendering + slide-in behavior as the rest of the theme. */
    window.SMrefreshMiniCart = function (open) {
        $.ajax({ url: '/cart.js', dataType: 'json' }).done(function (data) {
            var newItems = [];
            (data.items || []).forEach(function (ci) {
                var cf = ci.variant_title ? (' - ' + ci.variant_title) : '';
                newItems.push({
                    id: ci.id,
                    q: ci.quantity,
                    p: (ci.price / 100),
                    n: ci.product_title + cf,
                    gim: ci.image,
                    catid: ''
                });
            });
            SessionStorage.setItem('items', JSON.stringify(newItems));
            cartStatus(newItems);
            displayit(newItems);
            if (open) { showRightbar(); }
        });
    };
    window.SMopenMiniCart = function () { showRightbar(); };



    $(".product-rows").on("click", '.removeit', function (e) {

        e.preventDefault();
        e.stopPropagation();
        var subtotal = 0;
        var items = JSON.parse(SessionStorage.getItem("items"));
        var pid = $(this).data("id");
        var isexist = checkAlreadyExist(items, pid);

        if (isexist != -1) {

            var item = items[isexist];

            items[isexist] = ({
                id: pid,
                q: 0,
                p: item.p,
                n: item.n,
                gim: item.gim,
                catid: item.catid
            });

        }

        SessionStorage.setItem("items", JSON.stringify(items));
        var items = JSON.parse(SessionStorage.getItem("items"));
        if (checkTotalNumber(items) == 0) {
            hiddenRightbar();
        }
        refreshitembox();
        updatecart();
        // 9. Eliran Code : Add this line, updates cartStatus
        cartStatus(items);
        // End of code
        displayit(items);
    });

    function checkTotalNumber(items) {
        var subtotal = 0;
        $.each(items, function (key, value) {
            subtotal += value.q;
        });
        return subtotal;
    }

    function refresh() {
        var items = JSON.parse(SessionStorage.getItem("items"));
        var qu = 0;
        for (key in items) {
            if (!items[key])
                continue;
            qu += items[key].q;
        }
        if (qu > 0) {
            $("#gotocheckout").addClass("active");
            $("#cartQty").show();
        } else {
            $("#gotocheckout").removeClass("active");
            $("#cartQty").hide();
        }
    }
    refresh();

    $("#addBase").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263407857795
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_basebanner',
            'name': 'Add Base Banner',
            'creative': 'text',
            'position': 'body'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Base Banner');




    });


    $("#addDock").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263450456195
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_dockbanner',
            'name': 'Add Dock Banner',
            'creative': 'text',
            'position': 'body'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Dock Banner');




    });


    $('body').on('click', '.addb', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263407857795
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_base',
            'name': 'Add Base',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Base');
    });


    $('body').on('click', '.addtb', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var prods = {
            0: 33263399633027
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }

        ga('ec:addPromo', {
            'id': 'PROMO_baseandtop',
            'name': 'Add Base and Top',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Base and Top');


    });


    $('body').on('click', '.zmr', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33287239467139
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_zircorium',
            'name': 'Add Zicronium Medium Ring',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Zicronium Medium Ring');

    });


    $('body').on('click', '.addd', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263450456195
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_dock',
            'name': 'Add Dock',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Dock');
    });

    $('body').on('click', '.tmr', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33287187726467
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'promo_titanium_medium_ring',
            'name': 'Add Titanium Ring',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Titanium Ring');
    });


    $('body').on('click', '.adds', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263399633027
        };
        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_stand',
            'name': 'Add Stand',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Stand');
    });

    $('body').on('click', '.addas', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33263407857795
        };

        for (key in prods) {
            $("#vi-" + prods[key]).attr({ "selected": true });
            $("#vi-" + prods[key]).closest(".variant-wrap").find(".varidation-selection").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_stand',
            'name': 'Add Aluminium Stand',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Aluminium Stand');
    });


    $('body').on('click', '.addtr', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var prods = {
            0: 33287187726467
        };
        for (key in prods) {
            $("#vi-" + prods[key]).find(".qplus").trigger("click");
        }
        ga('ec:addPromo', {
            'id': 'PROMO_ring',
            'name': 'Add Titanium Ring',
            'creative': 'textandimage',
            'position': 'cart'
        });

        ga('ec:setAction', 'promo_click');
        ga('send', 'event', 'Internal Promotions', 'click', 'Add Titanium Ring');
    });




    var ispost = false;


    var total = 0;
    var sum = 0;
    var items = JSON.parse(SessionStorage.getItem("items"));

    for (n in items) {
        if (items[n] && items[n].q > 0) {
            total += items[n].p * items[n].q;
            sum += parseInt(items[n].q);
        }
    }

    // if (parseInt(total) == 0) {
    //     $(".cart_quanity1").html('');
    //     $(".cart_quantity .cart_empty").replaceWith("<span class='cart_empty'>Your cart is empty. <strong>Spend $69</strong> for free shipping<br/><a class='allproductss' href='#'>Add our Starter Pack!</a></span>");
    // }
    if (parseInt(total) == 0) {
        var items = JSON.parse(SessionStorage.getItem("items")) || [];
        var state = computeCartState(items);
        var rec = getRecommendation(state); // va sugera "Add Titanium die"
        renderRecommendation(rec, state);
    }
});



$("#giftcheck").click(function () {

    ga('ec:addPromo', {
        'id': 'PROMO_enterstore',
        'name': 'Enter Store',
        'creative': 'menu',
        'position': 'cart'
    });

    ga('ec:setAction', 'promo_click');
    ga('send', 'event', 'Internal Promotions', 'click', 'Enter Store');



});

var xhr;
var _syncedFromServer = _syncedFromServer || false; // dacă nu l-ai definit deja

function updatecart() {
    if (!_syncedFromServer) {
        console.log('Skipping updatecart - not synced from server yet');
        return; // nu împinge nimic înainte de primul /cart.js
    }

    var items = JSON.parse(SessionStorage.getItem("items")) || [];
    var updates = {};
    for (var key in items) {
        if (!items[key]) continue;                 // evită „găurile” din array
        updates[items[key].id] = items[key].q;
    }

    // Check if the payload is the same as last time
    var currentPayload = JSON.stringify(updates);
    if (updatecart._lastPayload === currentPayload) {
        console.log('Cart payload unchanged, skipping update');
        return;
    }

    // Debounce: așteaptă 500ms să se liniștească schimbările (increased from 300ms)
    clearTimeout(updatecart._t);
    updatecart._lastPayload = currentPayload;
    updatecart._t = setTimeout(function () {
        // Skip if we're already in progress
        if (updatecart._inProgress) {
            console.log('Cart update already in progress, skipping');
            return;
        }

        updatecart._inProgress = true;

        // Abort corect pe requestul anterior
        if (xhr && xhr.readyState !== 4) {
            try { xhr.abort(); } catch (e) { }
        }

        console.log('Updating cart with:', updates);
        xhr = jQuery.ajax({
            url: '/cart/update.js',
            type: 'POST',
            dataType: 'json',
            data: { updates: updates },
            complete: function () {
                updatecart._inProgress = false;
            },
            error: function (xhr, status, error) {
                console.error('Cart update failed:', xhr.status, error);
                updatecart._inProgress = false;
            }
        });
    }, 500);
}



var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};



discount = getUrlParameter('discount');
if (discount != null) {
    if (typeof (Storage) !== "undefined") {
        SessionStorage.setItem("discount", discount);
    }
}



if (SessionStorage.getItem("discount") !== null) {

    var discount = SessionStorage.getItem("discount");

    if (discount != '[]') {
        $('#gotocheckout').each(function () {
            this.href += '?discount=' + discount;
        })
    }

    if ($("#discount_input").length && discount != '[]') {

        $("#discount_input").val(SessionStorage.getItem("discount"));
        document.cookie = "discount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";

    } else {
        $("#discount_input").remove();
    }
}


$(document).ready(function ($) {


    if ($("#breakPoint").length) {
        var doclength = $("#breakPoint").offset().top;
        var winheight = $(window).height();
        var wintop = $(window).scrollTop();
    }

    $(window).resize(function () {
        if ($("#breakPoint").length) {
            doclength = $("#breakPoint").offset().top;
            winheight = $(window).height();
            wintop = $(window).scrollTop();
        }
    });
    $(window).on('load', function () {
        if ($("#breakPoint").length) {
            doclength = $("#breakPoint").offset().top;
            $(window).on("scroll", function () {
                winheight = $(window).height();
                wintop = $(window).scrollTop();

                if ((wintop + winheight - 108) >= doclength) {
                    if ($(".cart-area").hasClass("stick") == false) {
                        $("#breakPoint").css({
                            "padding-bottom": 0
                        });
                        $(".cart-area").addClass("stick");
                        $(".copyright").show();
                    }
                } else {
                    if ($(".cart-area").hasClass("stick") == true) {
                        $("#breakPoint").css({
                            "padding-bottom": 150
                        });
                        $(".cart-area").removeClass("stick");
                        $(".copyright").hide();
                    }
                }
            });
        }
    });
});

$(document).ready(function ($) {

    $(".weight").click(function () {
        $("p", this).toggle(300);
        $("i", this).toggleClass('fa-chevron-up fa-chevron-down');
        $(".weight").toggleClass('active');
    });


});





jQuery(document).ready(function () {
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('open_ring_sizer')) {
        $.magnificPopup.open({
            items: {
                src: '#ring-sizer'
            },
            type: 'inline',
            callbacks: {
                close: function () {
                    gtag('event', 'Ring Sizer Popup', { 'event_category': 'Ring Sizer', 'event_label': 'store page ring sizer' }); console.log("Ring Sizer Popup");
                    mixpanel.track("Ring Sizer Popup", {
                        "Action": "Ring Sizer Popup",
                        "Type": "Ring Sizer",
                        "Label": "Store Page Ring Sizer Popup"
                    });
                }
            }
        });
    }
})







